enum EGridLineDirection {
  Uniform = 'Uniform',
  Increasing = 'INCREASING',
  Decreasing = 'Decreasing',
  Random = 'Random',
}

export default EGridLineDirection;
